import { useState, useEffect } from "react";
import { StyledDashboard, JiraOverview } from "./styled";
import { Section } from "../../common/Section/styled";
import { ChangesLog } from "./ChangeLogs";
import { Concepts } from "./Concepts";
import { CurrentFeatures } from "./CurrentFeatures";
import { OptionalFeatures } from "./OptionalFeatures";
import { JiraIssueButton } from "./JiraIssueButton";
import { Loading } from "../../common/Loading";
import {
  getCurrentFeatures,
  getChangeLogs,
  getConceptsList,
} from "../../utils/getApi";
import { useParams } from "react-router-dom";
import { SummaryWorklogs } from "./SummaryWorklogs";

export const Dashboard = () => {
  const { databaseId } = useParams();
  const [loading, setLoading] = useState(true);
  const [currentFeatures, setCurrentFeatures] = useState(null);
  const [changeLogs, setChangeLogs] = useState(null);
  const [concepts, setConcepts] = useState(null);

  useEffect(() => {
    if (databaseId) {
      localStorage.setItem("databaseId", databaseId);
    }

    const fetchData = async () => {
      try {
        const features = await getCurrentFeatures(databaseId);
        const logs = await getChangeLogs(databaseId);
        const conceptsData = await getConceptsList(databaseId);

        setCurrentFeatures(features);
        setChangeLogs(logs);
        setConcepts(conceptsData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <StyledDashboard>
      <JiraOverview>
        <JiraIssueButton />
        <SummaryWorklogs />
      </JiraOverview>
      <Section>
        <OptionalFeatures data={currentFeatures} />
        <CurrentFeatures data={currentFeatures} />
      </Section>
      <Section>
        <ChangesLog data={changeLogs} />
        <Concepts data={concepts} />
      </Section>
    </StyledDashboard>
  );
};
